export default __webpack_public_path__ + "66ec1e0a585202422133f099496ee4a5.png";